export const UNKNOWN_EMPLOYER_LABEL = "Unknown employer";

type IncomeStreamLabelData = {
  employer?: { name?: string | null } | null;
  employment?: { employer?: { name?: string | null } | null } | null;
  income_description?: string | null;
};

export const getIncomeStreamLabel = (
  data: IncomeStreamLabelData,
  fallback = UNKNOWN_EMPLOYER_LABEL
) =>
  data.employer?.name?.trim() ||
  data.employment?.employer?.name?.trim() ||
  data.income_description?.trim() ||
  fallback;
